// status-webapp/src/api/jobs.ts
import { apiFetch } from "./client";

export interface Job {
  id: string; run_id: string; stage: string; state: string;
  actor: string; scope_json?: string | null;
  queued_at: string; started_at?: string | null;
  finished_at?: string | null; exit_code?: number | null;
  log_path?: string | null; error?: string | null;
}
export interface QueueSnapshot {
  waiting: Job[]; running: Job[]; awaiting_user: Job[]; recent: Job[];
}

export async function enqueueStage(runId: string, stage: string,
  body: { scope?: any } = {}): Promise<
    { job_id: string; state: string; slash_command?: string; skill_id?: string }
  > {
  return apiFetch(`/api/runs/${runId}/stages/${stage}/run`,
    { method: "POST", body: JSON.stringify(body) });
}

export async function cancelJob(jobId: string): Promise<void> {
  await apiFetch(`/api/jobs/${jobId}/cancel`, { method: "POST", body: "{}" });
}

export async function completeJob(jobId: string,
  body: { output_summary?: string; failed?: boolean } = {}): Promise<void> {
  await apiFetch(`/api/jobs/${jobId}/complete`,
    { method: "POST", body: JSON.stringify(body) });
}

export async function getQueue(): Promise<QueueSnapshot> { return apiFetch("/api/queue"); }
export async function getJob(id: string): Promise<Job> { return apiFetch(`/api/jobs/${id}`); }
export async function getJobLog(id: string): Promise<string> { return apiFetch(`/api/jobs/${id}/log`); }
